
<div class="p-10">
  <p-message severity="warn">Esta url es para hacer testing de los componentes publicos que iran en el wordpress</p-message>
</div>


<div class="wp-wrapper gray-wrapper">
  <div class="center-wrapper">
    <app-public-groups [tournamentIdInput]="tournamentId"></app-public-groups>
  </div>
</div>


<div class="wp-wrapper white-wrapper">
  <div class="center-wrapper">
    <app-public-standings [tournamentIdInput]="tournamentId"></app-public-standings>
  </div>
</div>


<div class="wp-wrapper gray-wrapper">
  <div class="center-wrapper">
    <app-public-rounds [tournamentIdInput]="tournamentId"></app-public-rounds>
  </div>
</div>
